import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import videoSrc from "../asset/homepage-vide-updated.mov";
import ProductSustainability from "../utiles/ProductSustainability";
import GetFeatured from "../utiles/Banners/GetFeatured";
import aboutbg1 from "../asset/about-bg-1.png";
import aboutbg2 from "../asset/about-bg-2.png";

const AboutUs: React.FC = () => {
  const { section } = useParams<{ section?: string }>();
  const aboutUsRef = useRef<HTMLDivElement>(null);
  const missionRef = useRef<HTMLDivElement>(null);
  const valuesRef = useRef<HTMLDivElement>(null);
  const contactRef = useRef<HTMLDivElement>(null);
  const productSustainabilityRef = useRef<HTMLDivElement>(null);
  const getFeaturedRef = useRef<HTMLDivElement>(null);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [nextImageIndex, setNextImageIndex] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const images = [aboutbg1, aboutbg2];

  useEffect(() => {
    switch (section) {
      case "mission":
        missionRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      case "values":
        valuesRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      case "contact":
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      case "sustainability":
        productSustainabilityRef.current?.scrollIntoView({
          behavior: "smooth",
        });
        break;
      case "featured":
        getFeaturedRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      default:
        aboutUsRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
    }
  }, [section]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="relative w-full h-screen overflow-hidden">
      <div className="absolute inset-0">
        <div className="container mx-auto px-4 md:px-6 text-center">
          {/* <div className="relative w-full h-[100vh] overflow-hidden">
            <img
              src={images[currentImageIndex]}
              className="absolute top-1/2 left-1/2 transition-opacity duration-1000"
              style={{
                objectFit: "contain",
                transform: "translate(-50%, -50%)",
                transformOrigin: "center",
                opacity: isTransitioning ? 0 : 1,
              }}
              alt={`About background ${currentImageIndex + 1}`}
            />
            <img
              src={images[nextImageIndex]}
              className="absolute top-1/2 left-1/2 transition-opacity duration-1000"
              style={{
                objectFit: "contain",
                transform: "translate(-50%, -50%)",
                transformOrigin: "center",
                opacity: isTransitioning ? 1 : 0,
              }}
              alt={`About background ${nextImageIndex + 1}`}
            />
          </div> */}
        </div>
      </div>
      <div className="relative z-10 w-full h-full overflow-auto hide-scrollbar">
        <div className="flex flex-col">
          {/* About Us Section */}
          <section
            ref={aboutUsRef}
            className="w-full h-screen flex items-center justify-center p-6 bg-gray-100 "
          >
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl font-semibold text-black mb-4">About Us</h1>
              <p className="text-lg   text-black">
                Welcome to Maysam, a homegrown startup based in Noida (Delhi NCR) dedicated to bringing you exquisite silver ornamental jewellery for women, men and children. As a manufacturer, we source our pure sterling silver bars from MMTC, a Government of India enterprise, ensuring the highest quality standards. Our in-house design team creates stunning pieces that cater to diverse tastes and age groups. Each order is packed with utmost care and perfection, ensuring a delightful unboxing experience. With a focus on customer satisfaction, our team of expert professionals ensures timely delivery with assured logistic company. At Maysam, we prioritize our customers' needs, providing a seamless online shopping experience. Discover our exclusive collection and experience the beauty of silver, crafted with love and precision.
              </p>
            </div>
          </section>

          {/* Our Mission Section */}
          <section
            ref={missionRef}
            className="w-full h-screen flex items-center justify-center p-6 bg-gray-100"
          >
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-4xl font-semibold text-black mb-4">Our Mission</h2>
              <p className="text-lg  text-black">
                Maysam creates inimitable pieces that can be worn for
                years. Each piece is crafted to be more than just clothing—it's
                an extension of who you are.
              </p>
            </div>
          </section>

          {/* Our Values Section */}
          <section
            ref={valuesRef}
            className="w-full h-screen flex items-center justify-center p-6 bg-gray-100"
          >
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-4xl font-semibold text-black mb-4">Our Values</h2>
              <p className="text-lg  text-black">
                After sketching the designs, we send them to our factories where
                the samples are created. Using bespoke illustrations and
                photography, all our prints and graphics are designed in-house.
              </p>
            </div>
          </section>

          {/* Contact Us Section */}
          <section
            ref={contactRef}
            className="w-full h-screen flex items-center justify-center p-6 bg-gray-100"
          >
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-4xl font-semibold text-black mb-4">Contact Us</h2>
              <p className="text-lg text-black">
                If you have any questions or would like to know more about Maysam and our products, feel free to reach out to us.
              </p>
            </div>
          </section>

          {/* Product Sustainability Section */}
          {/* <section ref={productSustainabilityRef}>
            <ProductSustainability />
          </section> */}

          {/* Get Featured Section */}
          <section
            ref={getFeaturedRef}
            className="w-full h-screen flex items-center justify-center p-6 bg-gray-100"
          >
            <GetFeatured />
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
